import { stringify } from 'qs';
import request from '@/utils/request';
import { loginOrg, loginCompany, loginUser } from '@/utils/LoginContext';

export async function customimportSave(payload) {
  return request(`/iwms-basic/basic/customimport`, {
    method: 'POST',
    body: payload,
  });
}

export async function query(payload) {
  return request(`/iwms-basic/basic/customimport/query?companyUuid=${loginCompany().uuid}&name=${payload.name}`, {
    method: 'POST',
    body: payload.orgUuids
  });
}

export async function remove(payload) {
  return request(`/iwms-basic/basic/customimport/remove?uuid=${payload.uuid}`, {
    method: 'POST'
  });
}

export async function get(payload) {
  return request(`/iwms-basic/basic/customimport/${payload.uuid}/get`, {
    method: 'GET'
  });
}

export async function modify(payload) {
  return request(`/iwms-basic/basic/customimport/modify`, {
    method: 'POST',
    body: payload
  })
}

export async function customImport(payload) {
  return request(`/iwms-basic/basic/customimport/import?fileKey=${payload.fileKey}&skipFirstRow=${payload.skipFirstRow}&uuid=${payload.uuid}&dcUuid=${loginOrg().type === 'DC' ? loginOrg().uuid : payload.dcUuid}`, {
    method: 'POST',
  })
}

export async function off(payload) {
  return request(`/iwms-basic/basic/customimport/offline?uuid=${payload.uuid}`, {
    method: 'POST'
  });
}

export async function online(payload) {
  return request(`/iwms-basic/basic/customimport/online?uuid=${payload.uuid}`, {
    method: 'POST'
  });
}
